import ValdostaHeroSection from "./components/HeroSection";
import ValdostaStickyNav from "./components/StickyNav";
import ValdostaProcessingTimeSection from "./components/ProcessingTimeSection";
import ValdostaServicesSection from "./components/ServicesSection";
import ValdostaLocalAreaSection from "./components/LocalAreaSection";
import ValdostaTestimonialsSection from "./components/TestimonialsSection";
import ValdostaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ValdostaComparisonSection from "./components/ComparisonSection";
import ValdostaMistakesSection from "./components/MistakesSection";
import ValdostaHowItWorksSection from "./components/HowItWorksSection";
import ValdostaFAQSection, { faqs } from "./components/FAQSection";
import ValdostaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import ValdostaFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function ValdostaPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Valdosta"
        state="Georgia"
        stateAbbr="GA"
        route="/cities/valdosta"
        title="Emergency Passport Valdosta, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Valdosta, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving south Georgia travelers. Get your emergency passport fast!"
        geoPlacename="Valdosta, Georgia"
        geoPosition="30.8327;-83.2785"
        keywords="expedited passport, emergency passport, Valdosta passport, same day passport Valdosta, fast passport Georgia, south Georgia passport"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
      />
      <ValdostaHeroSection />
      <ValdostaStickyNav />
      <ValdostaProcessingTimeSection />
      <ValdostaServicesSection />
      <ValdostaLocalAreaSection />
      <ValdostaTestimonialsSection />
      <ValdostaAcceptanceFacilitiesSection />
      <ValdostaComparisonSection />
      <ValdostaMistakesSection />
      <ValdostaHowItWorksSection />
      <ValdostaFAQSection />
      <ValdostaHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/valdosta" state="GA" />
      <ValdostaFinalCTA />
    </div>
  );
}